import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "warehouse-shell" }
const _hoisted_2 = { class: "wh-nav" }
const _hoisted_3 = { class: "wh-nav-group" }
const _hoisted_4 = {
  key: 0,
  class: "wh-nav-actions"
}
const _hoisted_5 = {
  key: 6,
  class: "section"
}
const _hoisted_6 = { class: "section-head" }
const _hoisted_7 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_8 = {
  key: 1,
  class: "cards-grid"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "card-photo" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "card-img-placeholder"
}
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "card-title" }
const _hoisted_15 = { class: "card-meta" }
const _hoisted_16 = {
  key: 7,
  class: "section"
}
const _hoisted_17 = { class: "section-head" }
const _hoisted_18 = { class: "toggle-check" }
const _hoisted_19 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_20 = { class: "area-title" }
const _hoisted_21 = { class: "area-count" }
const _hoisted_22 = {
  key: 0,
  class: "empty-hint-sm"
}
const _hoisted_23 = {
  key: 1,
  class: "cards-grid"
}
const _hoisted_24 = { class: "card-photo" }
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 1,
  class: "card-img-placeholder"
}
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = { class: "card-title" }
const _hoisted_29 = { class: "card-meta" }
const _hoisted_30 = { class: "qty-row" }
const _hoisted_31 = { class: "qty-badge qty--total" }
const _hoisted_32 = {
  key: 0,
  class: "qty-badge qty--cond"
}
const _hoisted_33 = { class: "card-footer" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "transfer-inline"
}
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "transfer-actions" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 2,
  class: "cards-grid"
}
const _hoisted_44 = { class: "card-photo" }
const _hoisted_45 = ["src"]
const _hoisted_46 = {
  key: 1,
  class: "card-img-placeholder"
}
const _hoisted_47 = { class: "card-body" }
const _hoisted_48 = { class: "card-title" }
const _hoisted_49 = { class: "card-meta" }
const _hoisted_50 = { class: "card-meta" }
const _hoisted_51 = { class: "qty-row" }
const _hoisted_52 = { class: "qty-badge qty--total" }
const _hoisted_53 = {
  key: 0,
  class: "qty-badge qty--cond"
}
const _hoisted_54 = { class: "card-footer" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = {
  key: 0,
  class: "transfer-inline"
}
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "transfer-actions" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 8,
  class: "section"
}
const _hoisted_65 = { class: "sub-block" }
const _hoisted_66 = {
  key: 0,
  class: "empty-hint-sm"
}
const _hoisted_67 = {
  key: 1,
  class: "req-list"
}
const _hoisted_68 = { class: "req-info" }
const _hoisted_69 = { class: "req-name" }
const _hoisted_70 = { class: "req-meta" }
const _hoisted_71 = { class: "status-chip chip--pending" }
const _hoisted_72 = {
  key: 0,
  class: "req-actions"
}
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { class: "sub-block" }
const _hoisted_76 = {
  key: 0,
  class: "empty-hint-sm"
}
const _hoisted_77 = {
  key: 1,
  class: "req-list"
}
const _hoisted_78 = { class: "req-info" }
const _hoisted_79 = { class: "req-name" }
const _hoisted_80 = { class: "req-meta" }
const _hoisted_81 = { class: "status-chip chip--info" }
const _hoisted_82 = { class: "sub-block" }
const _hoisted_83 = {
  key: 0,
  class: "empty-hint-sm"
}
const _hoisted_84 = {
  key: 1,
  class: "req-list"
}
const _hoisted_85 = { class: "req-info" }
const _hoisted_86 = { class: "req-name" }
const _hoisted_87 = { class: "req-meta" }
const _hoisted_88 = {
  key: 0,
  class: "req-meta req-notes"
}
const _hoisted_89 = {
  key: 0,
  class: "req-actions"
}
const _hoisted_90 = ["onClick"]
const _hoisted_91 = ["onClick"]
const _hoisted_92 = ["onClick"]
const _hoisted_93 = ["onClick"]
const _hoisted_94 = {
  key: 9,
  class: "section"
}
const _hoisted_95 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_96 = {
  width: "28",
  height: "28",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  style: {"animation":"spin 1s linear infinite"}
}
const _hoisted_97 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_98 = {
  key: 2,
  class: "reservations-timeline"
}
const _hoisted_99 = { class: "timeline-date" }
const _hoisted_100 = { class: "timeline-tools" }
const _hoisted_101 = { class: "tool-name" }
const _hoisted_102 = { class: "tool-qty" }
const _hoisted_103 = { class: "tool-task" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WarehouseNFeImportForm = _resolveComponent("WarehouseNFeImportForm")!
  const _component_WarehouseProvideEquipmentForm = _resolveComponent("WarehouseProvideEquipmentForm")!
  const _component_WarehouseAddItemForm = _resolveComponent("WarehouseAddItemForm")!
  const _component_WarehouseTransferItemForm = _resolveComponent("WarehouseTransferItemForm")!
  const _component_WarehouseDamageReportForm = _resolveComponent("WarehouseDamageReportForm")!
  const _component_WarehouseDamageDetailView = _resolveComponent("WarehouseDamageDetailView")!
  const _component_WarehouseDashboardWidget = _resolveComponent("WarehouseDashboardWidget")!
  const _component_WarehouseMovementHistoryModal = _resolveComponent("WarehouseMovementHistoryModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["wh-tab", { active: _ctx.isStockActive }]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openStock && _ctx.openStock(...args)))
        }, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("rect", {
              x: "2",
              y: "7",
              width: "20",
              height: "14",
              rx: "2"
            }),
            _createElementVNode("path", { d: "M16 7V5a2 2 0 0 0-4 0v2M8 7V5a2 2 0 0 0-4 0v2" })
          ], -1),
          _createTextVNode(" Estoque ", -1)
        ]))], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["wh-tab", { active: _ctx.isRequestsActive }]),
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openRequests && _ctx.openRequests(...args)))
        }, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("path", { d: "M9 11l3 3L22 4" }),
            _createElementVNode("path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" })
          ], -1),
          _createTextVNode(" Solicitações ", -1)
        ]))], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["wh-tab", { active: _ctx.isPlanejamentoActive }]),
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPlanejamento && _ctx.openPlanejamento(...args)))
        }, [...(_cache[16] || (_cache[16] = [
          _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("rect", {
              x: "3",
              y: "4",
              width: "18",
              height: "18",
              rx: "2"
            }),
            _createElementVNode("path", { d: "M16 2v4M8 2v4M3 10h18" })
          ], -1),
          _createTextVNode(" Planejamento ", -1)
        ]))], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["wh-tab", { active: _ctx.isDamagesActive }]),
          type: "button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openDamages && _ctx.openDamages(...args)))
        }, [...(_cache[17] || (_cache[17] = [
          _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
            _createElementVNode("line", {
              x1: "12",
              y1: "9",
              x2: "12",
              y2: "13"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "17",
              x2: "12.01",
              y2: "17"
            })
          ], -1),
          _createTextVNode(" Avarias ", -1)
        ]))], 2)
      ]),
      (!_ctx.isAnalyst)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass(["wh-action-btn", { active: _ctx.isProvideActive }]),
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openProvideForm && _ctx.openProvideForm(...args)))
            }, [...(_cache[18] || (_cache[18] = [
              _createElementVNode("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.2"
              }, [
                _createElementVNode("path", { d: "M5 12h14M12 5l7 7-7 7" })
              ], -1),
              _createTextVNode(" Fornecer ", -1)
            ]))], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["wh-action-btn", { active: _ctx.isAddItemActive }]),
              type: "button",
              onClick: _cache[5] || (_cache[5] = () => _ctx.openAddItemForm())
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.2"
              }, [
                _createElementVNode("line", {
                  x1: "12",
                  y1: "5",
                  x2: "12",
                  y2: "19"
                }),
                _createElementVNode("line", {
                  x1: "5",
                  y1: "12",
                  x2: "19",
                  y2: "12"
                })
              ], -1),
              _createTextVNode(" Adicionar ", -1)
            ]))], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["wh-action-btn", { active: _ctx.isTransferItemActive }]),
              type: "button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openTransferItemForm && _ctx.openTransferItemForm(...args)))
            }, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.2"
              }, [
                _createElementVNode("path", { d: "M17 1l4 4-4 4" }),
                _createElementVNode("path", { d: "M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4" }),
                _createElementVNode("path", { d: "M21 13v2a4 4 0 0 1-4 4H3" })
              ], -1),
              _createTextVNode(" Transferir ", -1)
            ]))], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["wh-action-btn", { active: _ctx.mode === 'nfe-import' }]),
              type: "button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openNfeImport && _ctx.openNfeImport(...args)))
            }, [...(_cache[21] || (_cache[21] = [
              _createStaticVNode("<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" data-v-92eaee3c><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-92eaee3c></path><polyline points=\"14 2 14 8 20 8\" data-v-92eaee3c></polyline><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"12\" data-v-92eaee3c></line><line x1=\"9\" y1=\"15\" x2=\"15\" y2=\"15\" data-v-92eaee3c></line></svg> Importar NF ", 2)
            ]))], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.mode === 'nfe-import')
      ? (_openBlock(), _createBlock(_component_WarehouseNFeImportForm, {
          key: 0,
          onCancel: _ctx.openStock,
          onDone: _ctx.onNfeImportDone
        }, null, 8, ["onCancel", "onDone"]))
      : (_ctx.mode === 'provide')
        ? (_openBlock(), _createBlock(_component_WarehouseProvideEquipmentForm, { key: 1 }))
        : (_ctx.mode === 'add-item')
          ? (_openBlock(), _createBlock(_component_WarehouseAddItemForm, { key: 2 }))
          : (_ctx.mode === 'transfer-item')
            ? (_openBlock(), _createBlock(_component_WarehouseTransferItemForm, { key: 3 }))
            : (_ctx.mode === 'damage-form')
              ? (_openBlock(), _createBlock(_component_WarehouseDamageReportForm, { key: 4 }))
              : (_ctx.mode === 'damage-detail')
                ? (_openBlock(), _createBlock(_component_WarehouseDamageDetailView, {
                    key: 5,
                    "can-resolve": _ctx.canResolveDamage
                  }, null, 8, ["can-resolve"]))
                : (_ctx.mode === 'damages')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "section-title" }, "Avarias", -1)),
                        _createElementVNode("button", {
                          class: "toggle-btn",
                          type: "button",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showResolvedHistory = !_ctx.showResolvedHistory))
                        }, _toDisplayString(_ctx.showResolvedHistory ? 'Ver pendentes' : 'Ver histórico'), 1)
                      ]),
                      (_ctx.filteredDamages.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[23] || (_cache[23] = [
                            _createElementVNode("svg", {
                              width: "36",
                              height: "36",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.4"
                            }, [
                              _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
                              _createElementVNode("line", {
                                x1: "12",
                                y1: "9",
                                x2: "12",
                                y2: "13"
                              }),
                              _createElementVNode("line", {
                                x1: "12",
                                y1: "17",
                                x2: "12.01",
                                y2: "17"
                              })
                            ], -1),
                            _createTextVNode(" Nenhuma avaria para esta visão. ", -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDamages, (entry) => {
                              return (_openBlock(), _createElementBlock("article", {
                                key: entry.id,
                                class: "item-card damage-clickable",
                                onClick: ($event: any) => (_ctx.openDamageDetail(entry.id))
                              }, [
                                _createElementVNode("div", _hoisted_10, [
                                  (_ctx.itemPhotoById(entry.toolItemId))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "card-img",
                                        src: _ctx.itemPhotoById(entry.toolItemId),
                                        alt: "foto item"
                                      }, null, 8, _hoisted_11))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[24] || (_cache[24] = [
                                        _createElementVNode("svg", {
                                          width: "28",
                                          height: "28",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "1.4"
                                        }, [
                                          _createElementVNode("rect", {
                                            x: "3",
                                            y: "3",
                                            width: "18",
                                            height: "18",
                                            rx: "3"
                                          }),
                                          _createElementVNode("circle", {
                                            cx: "8.5",
                                            cy: "8.5",
                                            r: "1.5"
                                          }),
                                          _createElementVNode("polyline", { points: "21 15 16 10 5 21" })
                                        ], -1)
                                      ]))]))
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.itemName(entry.toolItemId)), 1),
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(entry.damageSummary || entry.title || '-'), 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["status-chip", entry.status === 'resolvido' ? 'chip--ok' : 'chip--warn'])
                                  }, _toDisplayString(entry.status), 3)
                                ])
                              ], 8, _hoisted_9))
                            }), 128))
                          ]))
                    ]))
                  : (_ctx.tab === 'estoque')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                        _createVNode(_component_WarehouseDashboardWidget),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[26] || (_cache[26] = _createElementVNode("h2", { class: "section-title" }, "Estoque", -1)),
                          _createElementVNode("label", _hoisted_18, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.organizeByArea) = $event)),
                              type: "checkbox"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.organizeByArea]
                            ]),
                            _cache[25] || (_cache[25] = _createTextVNode(" Por área ", -1))
                          ])
                        ]),
                        (_ctx.items.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[27] || (_cache[27] = [
                              _createElementVNode("svg", {
                                width: "36",
                                height: "36",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "1.4"
                              }, [
                                _createElementVNode("rect", {
                                  x: "2",
                                  y: "7",
                                  width: "20",
                                  height: "14",
                                  rx: "2"
                                }),
                                _createElementVNode("path", { d: "M16 7V5a2 2 0 0 0-4 0v2M8 7V5a2 2 0 0 0-4 0v2" })
                              ], -1),
                              _createTextVNode(" Nenhum item no estoque. ", -1)
                            ]))]))
                          : (_ctx.organizeByArea)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.groupedItemsByArea, (group) => {
                                return (_openBlock(), _createElementBlock("section", {
                                  key: group.id,
                                  class: "area-section"
                                }, [
                                  _createElementVNode("h3", _hoisted_20, [
                                    _cache[28] || (_cache[28] = _createElementVNode("svg", {
                                      width: "13",
                                      height: "13",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.2"
                                    }, [
                                      _createElementVNode("path", { d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" }),
                                      _createElementVNode("circle", {
                                        cx: "12",
                                        cy: "10",
                                        r: "3"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(group.name) + " ", 1),
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(group.items.length), 1)
                                  ]),
                                  (group.items.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Sem itens nesta área."))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                                          return (_openBlock(), _createElementBlock("article", {
                                            key: item.id,
                                            class: "item-card"
                                          }, [
                                            _createElementVNode("div", _hoisted_24, [
                                              (item.photoDataUrl)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    class: "card-img",
                                                    src: _ctx.$resolveUrl(item.photoDataUrl),
                                                    alt: "foto item"
                                                  }, null, 8, _hoisted_25))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[29] || (_cache[29] = [
                                                    _createElementVNode("svg", {
                                                      width: "28",
                                                      height: "28",
                                                      viewBox: "0 0 24 24",
                                                      fill: "none",
                                                      stroke: "currentColor",
                                                      "stroke-width": "1.4"
                                                    }, [
                                                      _createElementVNode("rect", {
                                                        x: "3",
                                                        y: "3",
                                                        width: "18",
                                                        height: "18",
                                                        rx: "3"
                                                      }),
                                                      _createElementVNode("circle", {
                                                        cx: "8.5",
                                                        cy: "8.5",
                                                        r: "1.5"
                                                      }),
                                                      _createElementVNode("polyline", { points: "21 15 16 10 5 21" })
                                                    ], -1)
                                                  ]))]))
                                            ]),
                                            _createElementVNode("div", _hoisted_27, [
                                              _createElementVNode("div", _hoisted_28, _toDisplayString(item.name), 1),
                                              _createElementVNode("div", _hoisted_29, _toDisplayString(item.category) + " · " + _toDisplayString(item.code), 1),
                                              _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["qty-badge", item.availableQuantity <= item.quantityMin ? 'qty--low' : 'qty--ok'])
                                                }, _toDisplayString(item.availableQuantity) + " disp. ", 3),
                                                _createElementVNode("span", _hoisted_31, _toDisplayString(item.quantityTotal) + " total", 1),
                                                (item.conditionStatus)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(item.conditionStatus), 1))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_33, [
                                              _createElementVNode("button", {
                                                class: "card-btn",
                                                type: "button",
                                                onClick: ($event: any) => (_ctx.viewItem(item.id))
                                              }, [...(_cache[30] || (_cache[30] = [
                                                _createElementVNode("svg", {
                                                  width: "13",
                                                  height: "13",
                                                  viewBox: "0 0 24 24",
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  "stroke-width": "2"
                                                }, [
                                                  _createElementVNode("circle", {
                                                    cx: "11",
                                                    cy: "11",
                                                    r: "8"
                                                  }),
                                                  _createElementVNode("path", { d: "m21 21-4.35-4.35" })
                                                ], -1),
                                                _createTextVNode(" Info ", -1)
                                              ]))], 8, _hoisted_34),
                                              _createElementVNode("button", {
                                                class: "card-btn",
                                                type: "button",
                                                onClick: ($event: any) => (_ctx.openMovementHistory(item.id, item.name))
                                              }, [...(_cache[31] || (_cache[31] = [
                                                _createElementVNode("svg", {
                                                  width: "13",
                                                  height: "13",
                                                  viewBox: "0 0 24 24",
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  "stroke-width": "2"
                                                }, [
                                                  _createElementVNode("path", {
                                                    d: "M3 3h18v18H3z",
                                                    opacity: "0"
                                                  }),
                                                  _createElementVNode("path", { d: "M12 8v4l3 3" }),
                                                  _createElementVNode("circle", {
                                                    cx: "12",
                                                    cy: "12",
                                                    r: "9"
                                                  })
                                                ], -1),
                                                _createTextVNode(" Histórico ", -1)
                                              ]))], 8, _hoisted_35),
                                              (!_ctx.isAnalyst)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("button", {
                                                      class: "card-btn",
                                                      type: "button",
                                                      onClick: ($event: any) => (_ctx.openAddItemForm(item.id))
                                                    }, [...(_cache[32] || (_cache[32] = [
                                                      _createElementVNode("svg", {
                                                        width: "13",
                                                        height: "13",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2"
                                                      }, [
                                                        _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                                                        _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                                                      ], -1),
                                                      _createTextVNode(" Editar ", -1)
                                                    ]))], 8, _hoisted_36),
                                                    _createElementVNode("button", {
                                                      class: "card-btn card-btn--warn",
                                                      type: "button",
                                                      onClick: ($event: any) => (_ctx.reportDamage(item.id))
                                                    }, [...(_cache[33] || (_cache[33] = [
                                                      _createElementVNode("svg", {
                                                        width: "13",
                                                        height: "13",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2"
                                                      }, [
                                                        _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
                                                        _createElementVNode("line", {
                                                          x1: "12",
                                                          y1: "9",
                                                          x2: "12",
                                                          y2: "13"
                                                        })
                                                      ], -1),
                                                      _createTextVNode(" Avaria ", -1)
                                                    ]))], 8, _hoisted_37),
                                                    _createElementVNode("button", {
                                                      class: "card-btn",
                                                      type: "button",
                                                      onClick: ($event: any) => (_ctx.openTransferArea(item.id, item.location))
                                                    }, [...(_cache[34] || (_cache[34] = [
                                                      _createElementVNode("svg", {
                                                        width: "13",
                                                        height: "13",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2"
                                                      }, [
                                                        _createElementVNode("path", { d: "M17 1l4 4-4 4" }),
                                                        _createElementVNode("path", { d: "M3 11V9a4 4 0 0 1 4-4h14" })
                                                      ], -1),
                                                      _createTextVNode(" Área ", -1)
                                                    ]))], 8, _hoisted_38)
                                                  ], 64))
                                                : _createCommentVNode("", true)
                                            ]),
                                            (_ctx.transferAreaItemId === item.id && !_ctx.isAnalyst)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                  _withDirectives(_createElementVNode("select", {
                                                    class: "transfer-select",
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.transferAreaProjectId) = $event))
                                                  }, [
                                                    _cache[35] || (_cache[35] = _createElementVNode("option", { value: "" }, "Sem área", -1)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                                                      return (_openBlock(), _createElementBlock("option", {
                                                        key: project.id,
                                                        value: project.id
                                                      }, _toDisplayString(project.name), 9, _hoisted_40))
                                                    }), 128))
                                                  ], 512), [
                                                    [_vModelSelect, _ctx.transferAreaProjectId]
                                                  ]),
                                                  _createElementVNode("div", _hoisted_41, [
                                                    _createElementVNode("button", {
                                                      class: "btn-save-sm",
                                                      type: "button",
                                                      onClick: ($event: any) => (_ctx.confirmTransferArea(item.id))
                                                    }, "Confirmar", 8, _hoisted_42),
                                                    _createElementVNode("button", {
                                                      class: "btn-cancel-sm",
                                                      type: "button",
                                                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.cancelTransferArea && _ctx.cancelTransferArea(...args)))
                                                    }, "Cancelar")
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ]))
                                ]))
                              }), 128))
                            : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                                  return (_openBlock(), _createElementBlock("article", {
                                    key: item.id,
                                    class: "item-card"
                                  }, [
                                    _createElementVNode("div", _hoisted_44, [
                                      (item.photoDataUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "card-img",
                                            src: _ctx.$resolveUrl(item.photoDataUrl),
                                            alt: "foto item"
                                          }, null, 8, _hoisted_45))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_46, [...(_cache[36] || (_cache[36] = [
                                            _createElementVNode("svg", {
                                              width: "28",
                                              height: "28",
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "1.4"
                                            }, [
                                              _createElementVNode("rect", {
                                                x: "3",
                                                y: "3",
                                                width: "18",
                                                height: "18",
                                                rx: "3"
                                              }),
                                              _createElementVNode("circle", {
                                                cx: "8.5",
                                                cy: "8.5",
                                                r: "1.5"
                                              }),
                                              _createElementVNode("polyline", { points: "21 15 16 10 5 21" })
                                            ], -1)
                                          ]))]))
                                    ]),
                                    _createElementVNode("div", _hoisted_47, [
                                      _createElementVNode("div", _hoisted_48, _toDisplayString(item.name), 1),
                                      _createElementVNode("div", _hoisted_49, _toDisplayString(item.category) + " · " + _toDisplayString(item.code), 1),
                                      _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.areaLabel(item.location)), 1),
                                      _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["qty-badge", item.availableQuantity <= item.quantityMin ? 'qty--low' : 'qty--ok'])
                                        }, _toDisplayString(item.availableQuantity) + " disp. ", 3),
                                        _createElementVNode("span", _hoisted_52, _toDisplayString(item.quantityTotal) + " total", 1),
                                        (item.conditionStatus)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(item.conditionStatus), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_54, [
                                      _createElementVNode("button", {
                                        class: "card-btn",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.viewItem(item.id))
                                      }, [...(_cache[37] || (_cache[37] = [
                                        _createElementVNode("svg", {
                                          width: "13",
                                          height: "13",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2"
                                        }, [
                                          _createElementVNode("circle", {
                                            cx: "11",
                                            cy: "11",
                                            r: "8"
                                          }),
                                          _createElementVNode("path", { d: "m21 21-4.35-4.35" })
                                        ], -1),
                                        _createTextVNode(" Info ", -1)
                                      ]))], 8, _hoisted_55),
                                      _createElementVNode("button", {
                                        class: "card-btn",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.openMovementHistory(item.id, item.name))
                                      }, [...(_cache[38] || (_cache[38] = [
                                        _createElementVNode("svg", {
                                          width: "13",
                                          height: "13",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2"
                                        }, [
                                          _createElementVNode("path", { d: "M12 8v4l3 3" }),
                                          _createElementVNode("circle", {
                                            cx: "12",
                                            cy: "12",
                                            r: "9"
                                          })
                                        ], -1),
                                        _createTextVNode(" Histórico ", -1)
                                      ]))], 8, _hoisted_56),
                                      (!_ctx.isAnalyst)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("button", {
                                              class: "card-btn",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.openAddItemForm(item.id))
                                            }, [...(_cache[39] || (_cache[39] = [
                                              _createElementVNode("svg", {
                                                width: "13",
                                                height: "13",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2"
                                              }, [
                                                _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                                                _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                                              ], -1),
                                              _createTextVNode(" Editar ", -1)
                                            ]))], 8, _hoisted_57),
                                            _createElementVNode("button", {
                                              class: "card-btn card-btn--warn",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.reportDamage(item.id))
                                            }, [...(_cache[40] || (_cache[40] = [
                                              _createElementVNode("svg", {
                                                width: "13",
                                                height: "13",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2"
                                              }, [
                                                _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
                                                _createElementVNode("line", {
                                                  x1: "12",
                                                  y1: "9",
                                                  x2: "12",
                                                  y2: "13"
                                                })
                                              ], -1),
                                              _createTextVNode(" Avaria ", -1)
                                            ]))], 8, _hoisted_58),
                                            _createElementVNode("button", {
                                              class: "card-btn",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.openTransferArea(item.id, item.location))
                                            }, [...(_cache[41] || (_cache[41] = [
                                              _createElementVNode("svg", {
                                                width: "13",
                                                height: "13",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2"
                                              }, [
                                                _createElementVNode("path", { d: "M17 1l4 4-4 4" }),
                                                _createElementVNode("path", { d: "M3 11V9a4 4 0 0 1 4-4h14" })
                                              ], -1),
                                              _createTextVNode(" Área ", -1)
                                            ]))], 8, _hoisted_59)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.transferAreaItemId === item.id && !_ctx.isAnalyst)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                          _withDirectives(_createElementVNode("select", {
                                            class: "transfer-select",
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.transferAreaProjectId) = $event))
                                          }, [
                                            _cache[42] || (_cache[42] = _createElementVNode("option", { value: "" }, "Sem área", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: project.id,
                                                value: project.id
                                              }, _toDisplayString(project.name), 9, _hoisted_61))
                                            }), 128))
                                          ], 512), [
                                            [_vModelSelect, _ctx.transferAreaProjectId]
                                          ]),
                                          _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("button", {
                                              class: "btn-save-sm",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.confirmTransferArea(item.id))
                                            }, "Confirmar", 8, _hoisted_63),
                                            _createElementVNode("button", {
                                              class: "btn-cancel-sm",
                                              type: "button",
                                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.cancelTransferArea && _ctx.cancelTransferArea(...args)))
                                            }, "Cancelar")
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                      ]))
                    : (_ctx.tab === 'solicitacoes')
                      ? (_openBlock(), _createElementBlock("section", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "sub-title" }, "Requisições do planejamento", -1)),
                            (_ctx.toolRequests.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_66, "Sem requisições pendentes."))
                              : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toolRequests, (entry) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: entry.id,
                                      class: "req-card"
                                    }, [
                                      _createElementVNode("div", _hoisted_68, [
                                        _createElementVNode("div", _hoisted_69, _toDisplayString(entry.itemName), 1),
                                        _createElementVNode("div", _hoisted_70, "Tarefa: " + _toDisplayString(entry.taskTitle) + " · Qty: " + _toDisplayString(entry.quantity), 1),
                                        _createElementVNode("span", _hoisted_71, _toDisplayString(entry.status), 1)
                                      ]),
                                      (!_ctx.isAnalyst)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                            _createElementVNode("button", {
                                              class: "req-btn req-btn--ok",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.respondToolRequest(entry.id, 'aprovado'))
                                            }, "Aprovar", 8, _hoisted_73),
                                            _createElementVNode("button", {
                                              class: "req-btn req-btn--deny",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.respondToolRequest(entry.id, 'reprovado'))
                                            }, "Reprovar", 8, _hoisted_74)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                          ]),
                          _createElementVNode("div", _hoisted_75, [
                            _cache[44] || (_cache[44] = _createElementVNode("h3", { class: "sub-title" }, "Reservas por tarefa", -1)),
                            (_ctx.reservations.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_76, "Sem reservas."))
                              : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reservations, (entry) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: entry.id,
                                      class: "req-card"
                                    }, [
                                      _createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.itemName(entry.itemId)), 1),
                                        _createElementVNode("div", _hoisted_80, _toDisplayString(entry.reserveStartDate) + " → " + _toDisplayString(entry.reserveEndDate) + " · Qty: " + _toDisplayString(entry.quantity), 1),
                                        _createElementVNode("span", _hoisted_81, _toDisplayString(entry.status), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                          ]),
                          _createElementVNode("div", _hoisted_82, [
                            _cache[45] || (_cache[45] = _createElementVNode("h3", { class: "sub-title" }, "Solicitações de colaboradores", -1)),
                            (_ctx.userRequests.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_83, "Sem solicitações."))
                              : (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRequests, (entry) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: entry.id,
                                      class: "req-card"
                                    }, [
                                      _createElementVNode("div", _hoisted_85, [
                                        _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.itemName(entry.itemId)), 1),
                                        _createElementVNode("div", _hoisted_87, _toDisplayString(entry.requesterUsername) + " · Qty: " + _toDisplayString(entry.quantity), 1),
                                        (entry.notes)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(entry.notes), 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["status-chip", entry.status === 3 ? 'chip--ok' : entry.status === 0 ? 'chip--pending' : 'chip--info'])
                                        }, _toDisplayString(_ctx.requestStatusLabel(entry.status)), 3)
                                      ]),
                                      (!_ctx.isAnalyst)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                            (entry.status === 0)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: "req-btn req-btn--ok",
                                                  type: "button",
                                                  onClick: ($event: any) => (_ctx.setUserRequestStatus(entry.id, 1))
                                                }, "Aprovar", 8, _hoisted_90))
                                              : _createCommentVNode("", true),
                                            (entry.status === 1)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 1,
                                                  class: "req-btn req-btn--ok",
                                                  type: "button",
                                                  onClick: ($event: any) => (_ctx.setUserRequestStatus(entry.id, 2))
                                                }, "Fornecido", 8, _hoisted_91))
                                              : _createCommentVNode("", true),
                                            (entry.status === 3)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 2,
                                                  class: "req-btn",
                                                  type: "button",
                                                  onClick: ($event: any) => (_ctx.requestUserReturn(entry.id))
                                                }, "Solicitar devolução", 8, _hoisted_92))
                                              : _createCommentVNode("", true),
                                            (entry.status === 4)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 3,
                                                  class: "req-btn req-btn--ok",
                                                  type: "button",
                                                  onClick: ($event: any) => (_ctx.setUserRequestStatus(entry.id, 5))
                                                }, "Devolvido", 8, _hoisted_93))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                          ])
                        ]))
                      : (_ctx.tab === 'planejamento')
                        ? (_openBlock(), _createElementBlock("section", _hoisted_94, [
                            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "section-head" }, [
                              _createElementVNode("h2", { class: "section-title" }, "Planejamento de ferramentas")
                            ], -1)),
                            (_ctx.isLoadingReservations)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_96, [...(_cache[46] || (_cache[46] = [
                                    _createElementVNode("path", {
                                      d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z",
                                      opacity: ".25"
                                    }, null, -1),
                                    _createElementVNode("path", { d: "M21 12a9 9 0 0 0-9-9" }, null, -1)
                                  ]))])),
                                  _cache[47] || (_cache[47] = _createTextVNode(" Carregando… ", -1))
                                ]))
                              : (Object.keys(_ctx.reservationsByDate).length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [...(_cache[48] || (_cache[48] = [
                                    _createElementVNode("svg", {
                                      width: "36",
                                      height: "36",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "1.4"
                                    }, [
                                      _createElementVNode("rect", {
                                        x: "3",
                                        y: "4",
                                        width: "18",
                                        height: "18",
                                        rx: "2"
                                      }),
                                      _createElementVNode("path", { d: "M16 2v4M8 2v4M3 10h18" })
                                    ], -1),
                                    _createTextVNode(" Nenhuma ferramenta reservada. ", -1)
                                  ]))]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reservationsByDate, (tools, dateKey) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: dateKey,
                                        class: "timeline-entry"
                                      }, [
                                        _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.formatDate(dateKey)), 1),
                                        _createElementVNode("div", _hoisted_100, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tools, (tool, idx) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: `${dateKey}-${idx}`,
                                              class: "tool-reservation"
                                            }, [
                                              _createElementVNode("div", _hoisted_101, _toDisplayString(tool.toolName), 1),
                                              _createElementVNode("div", _hoisted_102, _toDisplayString(tool.quantity) + "×", 1),
                                              _createElementVNode("div", _hoisted_103, _toDisplayString(tool.taskTitle), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                          ]))
                        : _createCommentVNode("", true),
    (_ctx.movementHistoryItemId)
      ? (_openBlock(), _createBlock(_component_WarehouseMovementHistoryModal, {
          key: 10,
          "item-id": _ctx.movementHistoryItemId,
          "item-name": _ctx.movementHistoryItemName,
          onClose: _ctx.closeMovementHistory
        }, null, 8, ["item-id", "item-name", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}